import type {
  InvoiceDocumentKind,
  InvoicePreviewResponse,
  IssueResponse,
} from "../types";
import { apiFetch } from "./client";

/** 発行枚数を消費せず、税率区分・発行状態・発行者情報の不足を確認する。 */
export function getInvoicePreview(documentId: number): Promise<InvoicePreviewResponse> {
  return apiFetch<InvoicePreviewResponse>(`/api/invoices/orders/${documentId}`);
}

/** 発行物は backend でアーカイブへ保存され、既発行なら同じ書類が返る。 */
export function issueInvoice(
  documentId: number,
  kind: InvoiceDocumentKind,
  reissue = false,
): Promise<IssueResponse> {
  return apiFetch<IssueResponse>(`/api/invoices/orders/${documentId}`, {
    method: "POST",
    body: { kind, reissue },
  });
}
